const AuthHeading = (props) => {
	const { heading, subheading } = props;
	return (
		<div className="auth-heading">
			<h2 className="auth-heading__title">
				{heading}
			</h2>
			<p className="auth-heading__description">{subheading}</p>
		</div>
	);
};

export default AuthHeading;
